import { CartState } from '../Context/Context'
import "./products.css"
import { BsHeart, BsCart2, BsSearch} from 'react-icons/bs';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import ProductData from '../Components/ProductData';
import { motion } from "framer-motion"
import { useState } from 'react';
import Tilt from 'react-tilt'


const Loadvariants = {
  hidden: { opacity: 0,
  },
  visible: { opacity: 1,
     transition: {
          type: "spring",
          duration: 7
     },   
  }
}
const Products = () => {

  const { state: {cart, products} , dispatch} = CartState();

    const [search, setSearch] = useState("")
      
    const handleChange = (e) => {
      setSearch(e.target.value)
    }

   const filteredProducts = products.filter((prod) => prod.title.toLowerCase().includes(search) )




  return (
    <section className='products__section'>
          <motion.div className="products__container"
          initial="hidden"
          animate="visible"
          variants={Loadvariants}
          exit={{
            x: "-100vw",
           transition:{ ease: 'easeInOut'}
          }}
          >

            <div className="shop__search">
            
              <input type="text" 
               className='search__click'
               name='search'
               placeholder='Search products here....'
              value={search}
              onChange={handleChange}
              />
                <div className="search__note">
                  <h3>Search Shop</h3>
                </div>
            </div>

                  <div className="popular__games catt"  >

                    <p className='catt__head'>Popular Games</p>
                    <Splide className="sec__cont"
                      options={ {
                        arrows: false,
                        pagination: false,
                        drag: "free",
                       gap: '1rem' ,
                        fixedWidth: "15rem", 
                      } }
                      
                    >
                    {
                      filteredProducts.map(prod => {
                        const {id, title, info, genre, price, category, img} = prod
                         if( category === "trending"){
                           return(
                            
                            <SplideSlide className="products__cat" key={id}>
                              <Tilt
                            options={{
                             scale: 1
                           }}
                           >
                            <div className="product__img">
                                <img src={img} alt="" />
                            </div>
                            <div className="prod__body">
                                <p className='genre'>{genre}</p>
                                <p className='title'>{title}</p>
                                <p className='price'>{price}</p>
            
                            </div>
                               
                               {
                                 cart.some(p => p.id === prod.id) ? (
                                  <button className='addtocart3'
                                  onClick={()=>{
                                    dispatch({
                                      type: "REMOVE_FROM_CART",
                                      payload: prod,

                                    })
                                  }}
                                  ><BsCart2 className='ii'/>REMOVE FROM CART</button>
                                 ) : (
                                  <button className='addtocart3'
                                  onClick={()=>{
                                    dispatch({
                                      type: "ADD_TO_CART",
                                      payload: prod,

                                    })
                                  }}
                                  ><BsCart2 className='ii'/>ADD TO CART</button>
                                 )
                               }
                          </Tilt>

                               
                          
                      </SplideSlide>
                     
                           )
                         
                         }
                       })
                     }
                    </Splide>
                    
                  </div>
                  <div className="popular__games catt"  >

                    <p className='catt__head'>Upcoming Games</p>
                    <Splide className="sec__cont"
                      options={ {
                        arrows: false,
                        pagination: false,
                        drag: "free",
                       gap: '1rem' ,
                        fixedWidth: "15rem", 
                      } }
                      
                    >
                    {
                       filteredProducts.map(prod => {
                        const {id, title, info, genre, price, category, img} = prod
                         if( category === "upcoming"){
                           return(
                            
                            <SplideSlide className="products__cat" key={id}>
                              <Tilt
                            options={{
                             scale: 1
                           }}
                           >
                            <div className="product__img">
                                <img src={img} alt="" />
                            </div>
                            <div className="prod__body">
                                <p className='genre'>{genre}</p>
                                <p className='title'>{title}</p>
                               
            
                            </div>
                              
                               {
                                 cart.some(p => p.id === prod.id) ? (
                                  <button className='addtocart4'
                                  onClick={()=>{
                                    dispatch({
                                      type: "REMOVE_FROM_CART",
                                      payload: prod,

                                    })
                                  }}
                                  ><BsCart2 className='ii'/>REMOVE FROM CART</button>
                                 ) : (
                                  <button className='addtocart4'
                                  onClick={()=>{
                                    dispatch({
                                      type: "ADD_TO_CART",
                                      payload: prod,

                                    })
                                  }}
                                  ><BsCart2 className='ii'/>PRE-ORDER</button>
                                 )
                               }
                              </Tilt>
                            
                      </SplideSlide>
                           )
                         
                         }
                       })
                     }
                    </Splide>
                    
                  </div>
                  

                  <div className="accessories_cate catt">
                  <p className='catt__head'>Accessories</p>
                    <div className="sec__cont">
                    <Splide className="access__body"
       options={ {
        rewind: true,
        perPage: 2,
        arrows: false,
        pagination: true,
        drag: "free",
        gap: "1rem",
        autoplay: "true",
        interval: 3000,
        speed: 500,
        perMove: 1,
        fixedWidth: "14rem",
        wheel: 'true',
        type: "loop"
        
      } }
      
      >
                    

        {
            ProductData.map((data) =>{
           const {id, title, price, img, category} = data
           if( category === "accessories"){
            return(
              
              <SplideSlide className="access__cat" key={id}>
                    <div className=" access__img">
                        <img src={img} alt="" />
                    </div>
                    <div className="access__body">
                        <p className='title'>{title}</p>
                        <p className='price'>{price}</p>
                    </div>
                       <BsHeart className='access__icon'/>
                       {
                                 cart.some(p => p.id === data.id) ? (
                                  <button className='addtocart2'
                                  onClick={()=>{
                                    dispatch({
                                      type: "REMOVE_FROM_CART",
                                      payload: data,
                                      

                                    })
                                  }}
                                  ><BsCart2 className='ii'/>REMOVE FROM CART</button>
                                 ) : (
                                  <button className='addtocart2'
                                  onClick={()=>{
                                    dispatch({
                                      type: "ADD_TO_CART",
                                      payload: data,

                                    })
                                  }}
                                  ><BsCart2 className='ii'/>ADD TO CART</button>
                                 )
                               }
                       
                    
              </SplideSlide>
          )
            
           }
              
            })
        }
      </Splide>

                    </div>
                
                  </div>
         

          
          </motion.div>

        
    </section>
  )
}

export default Products